

    import {Component, Prop, Vue} from 'vue-property-decorator';

    import store from '../store';
    import {api} from '../Api';
    import HealthSurveyQuestion from './HealthSurveyQuestion.vue';
    import {Question} from '../lib/Question';

    @Component({
        components: {
            HealthSurveyQuestion,
        },
    })
    export default class HealthSurvey extends Vue {
        @Prop() public orderId: any;

        validate(){
            if(!store.state.healthSurvey.length){
                store.commit('toggleHealthSurveyIsValid', false);
                store.commit('closeModal');
                return;
            }
            const isValid = store.state.healthSurvey.every((asset: any) => {
                return asset.questions.every((question: Question) => {
                    if(!question.stepValidation()){
                        console.log(question.label, question.options);
                    }
                    return question.stepValidation();
                });
            });
            store.commit('toggleHealthSurveyIsValid', isValid);
            store.commit('closeModal');
            return;
        }
        mounted(){
            if(!store.state.healthSurvey.length){
                api.loadSurveyForm(this.orderId).then((response) => {
                    store.dispatch('loadHealthSurvey', response.data.data);
                });
            }
        }
    }

